export const ENVIRONMENT = {
  onePlace : import.meta.env.VITE_ONEPLACE,
  baseUrlIcarus : import.meta.env.VITE_ICARUS_API,
  returnUrlIcarus : import.meta.env.VITE_ICARUS,
  base : import.meta.env.VITE_BASE_URL,
  authApi : import.meta.env.VITE_DEADALUS_API,
  domainApi : import.meta.env.VITE_ICARUS_API,
  buildVersion: import.meta.env.VITE_VERSION,
  enableDarkMode: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',

  authApiPath : {
    client : {
      getClientDatabaseName : import.meta.env.VITE_DEADALUS_API + '/client/GetClientDatabaseName',
    },
    region : {
      allRegions : import.meta.env.VITE_DEADALUS_API + '/region/GetAllRegions',
      regions : import.meta.env.VITE_DEADALUS_API + '/region',
    },
    user : {
      allUsers : import.meta.env.VITE_DEADALUS_API + '/user/GetAllUsers',
      getEmployees : import.meta.env.VITE_ICARUS_API + '/user/GetEmployees',
      getUserClaims : import.meta.env.VITE_DEADALUS_API + '/user/GetUserClaims',
      generateUserToken : import.meta.env.VITE_DEADALUS_API + '/user/GenerateUserToken',
      getIntegrationSystems : import.meta.env.VITE_DEADALUS_API + '/user/GetIntegrationSystems',
      getAddUsersModel : import.meta.env.VITE_DEADALUS_API + '/user/GetAddUsersModel',
      getRemoveUsersModel : import.meta.env.VITE_DEADALUS_API + '/user/GetRemoveUsersModel',
      importUsers : import.meta.env.VITE_DEADALUS_API + '/user/ImportUsers',
      removeUsers : import.meta.env.VITE_DEADALUS_API + '/user/RemoveUsers',
      userPreference : import.meta.env.VITE_DEADALUS_API + '/UserPreference',
    },
    widget : {
      getWidgets : import.meta.env.VITE_DEADALUS_API + '/widget/GetWidgets',
    },
  },
  domainApiPath : {
    client: {
      getUserClients: import.meta.env.VITE_ICARUS_API + '/client/UserClients',
    },
    home : {
      getClientConfiguration : import.meta.env.VITE_ICARUS_API + '/Home/GetClientConfiguration',
      getClientHome : import.meta.env.VITE_ICARUS_API + '/Home/GetClientHome',
      getClientHomeFAQ : import.meta.env.VITE_ICARUS_API + '/Home/GetClientHomeFAQ',
      getClientHelpVideos : import.meta.env.VITE_ICARUS_API + '/Home/GetClientHelpVideos',
      getClientFAQs : import.meta.env.VITE_ICARUS_API + '/Home/GetClientFAQs',
      updateClientHelpVideo : import.meta.env.VITE_ICARUS_API + '/Home/UpdateClientHelpVideo',
      updateClientFAQ : import.meta.env.VITE_ICARUS_API + '/Home/UpdateClientFAQ',
      updateClientInformation : import.meta.env.VITE_ICARUS_API + '/Home/UpdateClientInformation',
    },
    identification : {
      getIdentification : import.meta.env.VITE_ICARUS_API + '/identification/getIdentification',
      create : import.meta.env.VITE_ICARUS_API + '/identification/create',
      update : import.meta.env.VITE_ICARUS_API + '/identification/update',
    },
    reports: {
      getAllReports: import.meta.env.VITE_ICARUS_API + '/report/GetAllReports',
      getReportById: import.meta.env.VITE_ICARUS_API + '/report/GetReportById',
      reloadFields: import.meta.env.VITE_ICARUS_API + '/report/ReloadFields',
      saveReport: import.meta.env.VITE_ICARUS_API + '/report/SaveReport',
      deleteReport: import.meta.env.VITE_ICARUS_API + '/report/DeleteReport',
      exportReportSettings: import.meta.env.VITE_ICARUS_API + '/report/exportReportSettings',
      getAllReportsList: import.meta.env.VITE_ICARUS_API + '/report/GetAllReportsByValuation',
      testSQL: import.meta.env.VITE_ICARUS_API + '/report/TestSql',
      loadReport: import.meta.env.VITE_ICARUS_API + '/report/LoadReport',
      LoadReportFields: import.meta.env.VITE_ICARUS_API + '/report/LoadReportFields',
    },
    entities: {
      getEntity: import.meta.env.VITE_ICARUS_API + '/entity/GetEntity',
    },
    rules : {
      saveRule : import.meta.env.VITE_ICARUS_API + '/rule/saveRule',
      saveOrUpdateRule : import.meta.env.VITE_ICARUS_API + '/rule/SaveOrUpdateRule',
      getRules : import.meta.env.VITE_ICARUS_API + '/rule',
      exportRuleSettings : import.meta.env.VITE_ICARUS_API + '/rule/ExportRuleSettings',
      getRuleData : import.meta.env.VITE_ICARUS_API + '/rule/getRuleData',
      deleteRule : import.meta.env.VITE_ICARUS_API + '/rule/deleteRule',
      deleteRules : import.meta.env.VITE_ICARUS_API + '/rule/DeleteRules',
      updateRulesOrder : import.meta.env.VITE_ICARUS_API + '/rule/UpdateRulesOrder',
      getValuationErrors : import.meta.env.VITE_ICARUS_API + '/rule/getValuationErrors',
      getValuationsPopulation : import.meta.env.VITE_ICARUS_API + '/rule/getValuationsPopulation',
      getListObsRule : import.meta.env.VITE_ICARUS_API + '/rule/getListObsRule',
      exportDataProcessErrorsAnalytic :
        import.meta.env.VITE_ICARUS_API + '/rule/exportDataValuationErrorsAnalytic',
      exportDataProcessErrors : import.meta.env.VITE_ICARUS_API + '/rule/ExportDataValuationErrors',
      exportDataProcessErrorsPopulation :
        import.meta.env.VITE_ICARUS_API + '/rule/exportDataValuationErrorsPopulation',
      insertObsInRow : import.meta.env.VITE_ICARUS_API + '/rule/insertObsInRow',
      insertObsRule : import.meta.env.VITE_ICARUS_API + '/rule/insertObsRule',
      saveProcessRowsValues : import.meta.env.VITE_ICARUS_API + '/rule/saveValuationRowsValues',
      getProcessRow : import.meta.env.VITE_ICARUS_API + '/rule/getValuationRow',
      confirmRows : import.meta.env.VITE_ICARUS_API + '/rule/confirmRows',
      authorizeRule : import.meta.env.VITE_ICARUS_API + '/rule/authorizeRule',
      authorizeRuleAll : import.meta.env.VITE_ICARUS_API + '/rule/AuthorizeRuleAll',
      deleteRow : import.meta.env.VITE_ICARUS_API + '/rule/deleteRow',
    },
    valuations: {
      getValuations: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/getAllValuations',
      getValuation: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/GetValuationById',
      saveValuation: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/saveValuation',
      getListFilesValuation: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/getListFilesValuation',
      getValuationsList: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/getValuationsList',
      getValuationsNames: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/getValuationNames',
      deleteValuation: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/removeValuation',
      executeRules: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/executeRules',
      eraseValuationImport: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/eraseValuationImport',
      authorizeValuation: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/AuthorizeValuation',
      confirmClosedValuation: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/ConfirmClosedValuation',
      reopenValuation: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/ReopenValuation',
      exportValuationData: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/exportValuationData',
      getActuarialSubsidiaryInformation: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/GetActuarialSubsidiaryInformation',
      getAuthorizationActuarialSubsidiary: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/GetAuthorizationToActuarialSubsidiary',
      getAllSubsidiaries: import.meta.env.VITE_ICARUS_API + '/actuarialValuation/GetAllSubsidiaries',
      getPlanGroups : import.meta.env.VITE_ICARUS_API + '/actuarialValuation/GetPlanGroupsForValuation'
    },
    valuationImports:{
      getProcessedFiles: import.meta.env.VITE_ICARUS_API + '/valuationImports/GetValuationProcessedFiles',
      getUnprocessedFiles: import.meta.env.VITE_ICARUS_API + '/valuationImports/GetValuationUnprocessedFiles',
      validateAndImport: import.meta.env.VITE_ICARUS_API + '/valuationImports/validateAndImportValuation',
      validateAndImportAuxiliary: import.meta.env.VITE_ICARUS_API + '/valuationImports/validateAndImportValuationAuxiliary',
      updateExcelCellValue: import.meta.env.VITE_ICARUS_API + '/valuationImports/updateValuationExcelCellValue',
    },
    valuationChangeLog: {
      getLogForProcess: import.meta.env.VITE_ICARUS_API + '/ProcessChangeLog/GetLogForProcess',
      getProcessLogDetails:
        import.meta.env.VITE_ICARUS_API + '/ProcessChangeLog/GetProcessLogDetails',
      exportData: import.meta.env.VITE_ICARUS_API + '/ProcessChangeLog/ExportData',
    },
    logs : {
      getValuationLogs : import.meta.env.VITE_ICARUS_API + '/Log/GetValuationLog',
      getConfigurationLogs : import.meta.env.VITE_ICARUS_API + '/Log/GetConfigurationLog',
      exportConfigurationLogs : import.meta.env.VITE_ICARUS_API + '/Log/exportConfigurationLogs',
      getConfigurationLogsDetails : import.meta.env.VITE_ICARUS_API + '/Log/GetConfigurationLogDetails',
      getValuationLogDetails : import.meta.env.VITE_ICARUS_API + '/Log/GetValuationLogDetails',
      exportValuationLogs : import.meta.env.VITE_ICARUS_API + '/Log/exportValuationLogs',
    },
    planGroups : {
      getAll : import.meta.env.VITE_ICARUS_API + '/planGroup/GetPlanGroups',
      saveAndEdit : import.meta.env.VITE_ICARUS_API + '/planGroup/saveAndEdit',
      delete : import.meta.env.VITE_ICARUS_API + '/planGroup/delete',
    },
    user : {
      getEmployees: import.meta.env.VITE_ICARUS_API + '/user/GetEmployees',
    },
    fields: {
      getAll: import.meta.env.VITE_ICARUS_API + '/fields/GetAll',
      getAllPaged: import.meta.env.VITE_ICARUS_API + '/fields/GetAllPaged',
      getFieldsAndDVSId: import.meta.env.VITE_ICARUS_API + '/field/getFieldsList',
      get: import.meta.env.VITE_ICARUS_API + '/fields/getField',
      getFieldDependencyRules: import.meta.env.VITE_ICARUS_API + '/fields/GetFieldDependencyRules',
      getFieldDependencyReports: import.meta.env.VITE_ICARUS_API + '/fields/GetFieldDependencyReports',
      getComputedFieldsByField: import.meta.env.VITE_ICARUS_API + '/fields/getComputedFieldsByField',
      saveField: import.meta.env.VITE_ICARUS_API + '/fields/SaveOrUpdateField',
      deleteField: import.meta.env.VITE_ICARUS_API + '/fields/deleteField',
      batchDeleteFields: import.meta.env.VITE_ICARUS_API + '/fields/BatchDeleteFields',
      exportImportFieldsModel: import.meta.env.VITE_ICARUS_API + '/fields/ExportImportFieldsModel',
      importFields: import.meta.env.VITE_ICARUS_API + '/fields/ImportFields',
      exportFieldsSettings: import.meta.env.VITE_ICARUS_API + '/fields/ExportFieldsSettings',
      updateOrder: import.meta.env.VITE_ICARUS_API + '/fields/UpdateOrder',
    },
    wizard: {
      getImportData: import.meta.env.VITE_ICARUS_API + '/wizard/getImportData',
      executeRule: import.meta.env.VITE_ICARUS_API + '/rule/executeRule',
      sendFile: import.meta.env.VITE_ICARUS_API + '/wizard/sendFile',
      updateFile: import.meta.env.VITE_ICARUS_API + '/wizard/updateFile',
      getFile: import.meta.env.VITE_ICARUS_API + '/wizard/getFile',
      getImportedFile: import.meta.env.VITE_ICARUS_API + '/wizard/getImportedFile',
      getUnvaluationedFiles: import.meta.env.VITE_ICARUS_API + '/wizard/getUnvaluationedFiles',
      exportFile: import.meta.env.VITE_ICARUS_API + '/wizard/exportFileById',
      removeFile: import.meta.env.VITE_ICARUS_API + '/wizard/deleteFile',
      getFileByLayoutId: import.meta.env.VITE_ICARUS_API + '/wizard/getFileByLayoutId',
      saveLayoutIntegrationConfiguration: import.meta.env.VITE_ICARUS_API + '/wizard/saveLayoutIntegrationConfiguration',
      checkColumnCount: import.meta.env.VITE_ICARUS_API + '/wizard/checkColumnCount',
      validateAndImportCorrectionFile:
        import.meta.env.VITE_ICARUS_API + '/wizard/validateAndImportCorrectionFile',
      validateAndImportProcessCorrectionFile :
        import.meta.env.VITE_ICARUS_API + '/wizard/importCorrectionFileForValuation',
      sendIntegrationConfigurationFile :
        import.meta.env.VITE_ICARUS_API + '/wizard/sendIntegrationConfigurationFile',
      refreshFileStatus: import.meta.env.VITE_ICARUS_API + '/wizard/refreshFileStatus',
    },
    layout: {
      getConfiguredLayouts: import.meta.env.VITE_ICARUS_API + '/layout/GetConfiguredLayouts',
      getAuxiliaryConfiguredLayouts: import.meta.env.VITE_ICARUS_API + '/layout/GetAuxiliaryConfiguredLayouts',
      getLayoutFirstRow: import.meta.env.VITE_ICARUS_API + '/layout/GetLayoutFirstRow',
      saveLayoutMapping: import.meta.env.VITE_ICARUS_API + '/layout/saveLayoutMapping',
      getLayoutMapping: import.meta.env.VITE_ICARUS_API + '/layout/getLayoutMapping',
      reloadEditLayoutByModule: import.meta.env.VITE_ICARUS_API + '/layout/reloadEditLayoutByModule',
      removeLayout: import.meta.env.VITE_ICARUS_API + '/layout/deleteLayout',
      exportLayout: import.meta.env.VITE_ICARUS_API + '/layout/exportLayout',
      setDefaultLayout: import.meta.env.VITE_ICARUS_API + '/layout/setDefaultLayout',
      getDefaultLayout: import.meta.env.VITE_ICARUS_API + '/layout/getDefaultLayout',
      saveLayoutMappingAuxiliary: import.meta.env.VITE_ICARUS_API + '/layout/saveLayoutMappingAuxiliary',
      getDistinctColumnValues: import.meta.env.VITE_ICARUS_API + '/layout/GetDistinctColumnValues',
    },
    variable: {
      getAllPaginatedVariables: import.meta.env.VITE_ICARUS_API + '/variable/getAllPaginatedVariables',
      createVariable: import.meta.env.VITE_ICARUS_API + '/variable/createVariable',
      updateVariable: import.meta.env.VITE_ICARUS_API + '/variable/updateVariable',
      getVariableById: import.meta.env.VITE_ICARUS_API + '/variable/getVariableById',
      getEntitiesAffectedByDeletion: import.meta.env.VITE_ICARUS_API + '/variable/getEntitiesAffectedByDeletion',
      batchDeleteVariables: import.meta.env.VITE_ICARUS_API + '/variable/batchDeleteVariables',
      getVariablesValueByValuation: import.meta.env.VITE_ICARUS_API + '/variable/getVariablesValueByValuation',
    },
    enumeration : {
      getAllEnumerators : import.meta.env.VITE_ICARUS_API + '/enumerator/getAllEnumerators',
      getById : import.meta.env.VITE_ICARUS_API + '/enumerator/GetEnumeratorById',
      getEnumeratorsData : import.meta.env.VITE_ICARUS_API + '/enumerator/GetEnumeratorsData',
      create : import.meta.env.VITE_ICARUS_API + '/enumerator/createEnumerator',
      update : import.meta.env.VITE_ICARUS_API + '/enumerator/updateEnumerator',
      delete : import.meta.env.VITE_ICARUS_API + '/enumerator/deleteEnumerator',
      readValues : import.meta.env.VITE_ICARUS_API + '/enumerator/readValues',
      getAvailableAccessFilters :
        import.meta.env.VITE_ICARUS_API + '/enumerator/GetAvailableAccessFilters',
      getEnumeratorValues : import.meta.env.VITE_ICARUS_API + '/enumerator/GetEnumeratorValues',
      updateEnumeratorValues :
        import.meta.env.VITE_ICARUS_API + '/enumerator/updateEnumeratorValues',
    },
    templatesEmail : {
      getAllTemplates : import.meta.env.VITE_ICARUS_API + '/TemplatesEmail/GetAllTemplates',
      getById : import.meta.env.VITE_ICARUS_API + '/TemplatesEmail/GetById',
      getTags : import.meta.env.VITE_ICARUS_API + '/TemplatesEmail/GetTags',
      createTemplatesEmail :
        import.meta.env.VITE_ICARUS_API + '/TemplatesEmail/CreateTemplatesEmail',
      alterTemplatesEmail : import.meta.env.VITE_ICARUS_API + '/TemplatesEmail/AlterTemplatesEmail',
      deleteTemplatesEmail :
        import.meta.env.VITE_ICARUS_API + '/TemplatesEmail/DeleteTemplatesEmail',
    },
    widget : {
      getAll : import.meta.env.VITE_ICARUS_API + '/widget/getAll',
      getImportValuationData : import.meta.env.VITE_ICARUS_API + '/widget/getImportValuationData',
      getWidgetConfigById : import.meta.env.VITE_ICARUS_API + '/widget/getWidgetConfigById',
      getParticipantsWidgetData :
        import.meta.env.VITE_ICARUS_API + '/widget/getParticipantsWidgetData',
      getParticipantsWidgetRangeData :
        import.meta.env.VITE_ICARUS_API + '/widget/getParticipantsWidgetRangeData',
      update : import.meta.env.VITE_ICARUS_API + '/widget/update',
      add : import.meta.env.VITE_ICARUS_API + '/widget/add',
      getParticipantsData : import.meta.env.VITE_ICARUS_API + '/widget/getParticipantsData',
      getProfitabilityData : import.meta.env.VITE_ICARUS_API + '/widget/getProfitabilityData',
      getProfitabilityWidgetData :
        import.meta.env.VITE_ICARUS_API + '/widget/getProfitabilityWidgetData',
      delete : import.meta.env.VITE_ICARUS_API + '/widget/delete',
      getProcessesYears : import.meta.env.VITE_ICARUS_API + '/widget/getProcessesYears',
    },
    dataMapping : {
      getFields : import.meta.env.VITE_ICARUS_API + '/MapConfig',
      saveFields : import.meta.env.VITE_ICARUS_API + '/MapConfig',
    },
  },
  storageApiPath : {
    storageTags : {
      getStorageTags : import.meta.env.VITE_STORAGE_API + '/StorageTags/GetStorageTags',
      getStorageTagsInfo : import.meta.env.VITE_STORAGE_API + '/StorageTags/GetStorageTagsInfo',
      getCustomStorageTags : import.meta.env.VITE_STORAGE_API + '/StorageTags/GetCustomStorageTags',
      getMandatoryStorageTags :
        import.meta.env.VITE_STORAGE_API + '/StorageTags/GetMandatoryStorageTags',
      getTagCategories : import.meta.env.VITE_STORAGE_API + '/StorageTags/GetCategories',
      createCategory : import.meta.env.VITE_STORAGE_API + '/StorageTags/CreateCategory',
      updateCategory : import.meta.env.VITE_STORAGE_API + '/StorageTags/UpdateCategory',
      removeTagCategory : import.meta.env.VITE_STORAGE_API + '/StorageTags/RemoveTagCategory',
      updateCategoryRoles : import.meta.env.VITE_STORAGE_API + '/StorageTags/UpdateCategoryRoles',
      createTag : import.meta.env.VITE_STORAGE_API + '/StorageTags/CreateTag',
      updateTag : import.meta.env.VITE_STORAGE_API + '/StorageTags/UpdateTag',
      removeTag : import.meta.env.VITE_STORAGE_API + '/StorageTags/RemoveTag',
    },
    storageFiles : {
      getStorageFiles : import.meta.env.VITE_STORAGE_API + '/StorageFiles/GetStorageFiles',
      getStorageFileLogs : import.meta.env.VITE_STORAGE_API + '/StorageFiles/GetStorageFileLogs',
      getAllFolders : import.meta.env.VITE_STORAGE_API + '/StorageFiles/GetAllFolders',
      getRecentFolders : import.meta.env.VITE_STORAGE_API + '/StorageFiles/GetRecentFolders',
      getRecentFiles : import.meta.env.VITE_STORAGE_API + '/StorageFiles/GetRecentFiles',
      downloadFile : import.meta.env.VITE_STORAGE_API + '/StorageFiles/DownloadFile',
      createFolder : import.meta.env.VITE_STORAGE_API + '/StorageFiles/CreateFolder',
      uploadFile : import.meta.env.VITE_STORAGE_API + '/StorageFiles/UploadFile',
      renameFile : import.meta.env.VITE_STORAGE_API + '/StorageFiles/RenameFile',
      updateFileTags : import.meta.env.VITE_STORAGE_API + '/StorageFiles/UpdateFileTags',
      moveFile : import.meta.env.VITE_STORAGE_API + '/StorageFiles/MoveFile',
      removeFile : import.meta.env.VITE_STORAGE_API + '/StorageFiles/RemoveFile',
      removeFolder : import.meta.env.VITE_STORAGE_API + '/StorageFiles/RemoveFolder',
      duplicateFile : import.meta.env.VITE_STORAGE_API + '/StorageFiles/DuplicateFile',
    },
  },
  configurations : {
    maximumNumberOfFiles : 15,
    maximumFileSize : 5120000,
  },
};
